import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_1839d5 = setTheme(({ theme }) => `background-color: ${theme.colors.color_1839d5}`);
